import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    header: ({ requesterNameAndEmail, resourceName }: {
        requesterNameAndEmail: string;
        resourceName: string;
    }) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Access Request Header Text */
            header: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ requesterNameAndEmail, resourceName }: {
                        requesterNameAndEmail: string;
                        resourceName: string;
                    }) => __intl__.intl().formatMessage({ id: "AccessRequestHeader.header?c=2qhv9bjawvr8n", defaultMessage: "{requesterNameAndEmail} requested access to {resourceName}" }, { requesterNameAndEmail: requesterNameAndEmail, resourceName: resourceName }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
